import { Component, OnInit, Inject, PLATFORM_ID, AfterViewInit, ChangeDetectorRef, OnDestroy, ViewChild, ElementRef, NgZone, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NeproseService } from 'src/app/services/neprose.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { WindowRef } from 'src/app/Window/WindowRef';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import {NgxGalleryOptions} from '@kolkov/ngx-gallery';
import {NgxGalleryImage} from '@kolkov/ngx-gallery';
import { AuthService } from 'src/app/services/auth.service';
import { SeoSocialShareService } from 'ngx-seo';

declare const google: any;

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit{

  adId: any

  property: any

  url: string

  provinceList = []

  districtList = []

  municipalityList = []

  address: any

  seller: Observable<any>

  galleryOptions: NgxGalleryOptions[]

  galleryImages: NgxGalleryImage[] = []

  otherFacilities = []

  @ViewChild('mapContainer', {static: false}) gmap: ElementRef

  @ViewChild('directionsPanel', {static: false}) direction: ElementRef

  @ViewChild('location', {static: false}) location: ElementRef;

  map: google.maps.Map;

  coordinates: any

  mapOptions: google.maps.MapOptions

  infoWindow: google.maps.InfoWindow

  marker: any

  currentMarker: any

  similarProperties = []

  backgroundImageURL: any = this._sanitizer.bypassSecurityTrustStyle(`url(${'assets/colony.jpg'})`+` no-repeat center center`)

  loggedIn: boolean 

  notFavourite: boolean = true

  favourite: any

  localAds = []

  firstAd: any

  secondAd: any

  thirdAd: any

  currentLat: any
  
  currentLong: any

  directionsService = new google.maps.DirectionsService()

  directionsRenderer = new google.maps.DirectionsRenderer()

  autocomplete: any

  options = {
    componentRestrictions: {country: 'np'}
  };

  selectedMode: string = 'DRIVING'

  mapLoaded: boolean

  constructor(private route: ActivatedRoute, private _neproseService: NeproseService, @Inject(PLATFORM_ID) protected platformId: Object, private window: WindowRef,
  private _sanitizer: DomSanitizer, private cdr: ChangeDetectorRef, private _authService: AuthService, private _router: Router, private seo: SeoSocialShareService, private _ngZone: NgZone,
  private renderer: Renderer2 ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: { provinceList: any, districtList: any, municipalityList: any, propertyAd: any }) =>{
      this.provinceList = data.provinceList.provinces
      this.districtList = data.districtList.districts
      this.municipalityList = data.municipalityList.municipalities
      if(data.propertyAd.propertyAd.status == 'completed' || data.propertyAd.propertyAd.status == 'sold'){
        this.property = data.propertyAd.propertyAd
        let image = environment.url+'/assets/logo.png'
        let excerpt = this.property.details.replace(/<\/?[^>]+(>|$)/g, '')
        this.seo.setTitle(this.property.title)
        if(excerpt){
          this.seo.setDescription(excerpt.slice(0, 200))
        }
        if(this.property.PropertyImage){
          let propertyImages = JSON.parse(this.property.PropertyImage.imagePath)
          if(propertyImages.length > 0){
            image = environment.api+'/images/'+propertyImages[0]
            this.seo.setImage(image)
          }
        }
        this.handleRouteChanges()
      }else{
        this._router.navigate(['404'])
      }
    })
  }

  handleRouteChanges(){  
    this.setAdvertisement()
    this.setGalleryOptions()
    this.adId = this.route.snapshot.params.id
    this.url = environment.url + '/property/' + this.adId
    this.setIpAddress()
    this.isFavourite()
    this.prepareAdvertisement() 
    this.getSimialarProperties()
    this.cdr.detectChanges()
    this._ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.mapInitializer()
        this.initializeShareButton()
        this.findMe()
        this.cdr.detectChanges()
      }, 2000)
    })   
  } 

  setGalleryOptions(){
    this.galleryOptions = [
        { 
          width: '100%', 
          height: '70vh', 
          "imageArrowsAutoHide": true, 
          "thumbnailsArrowsAutoHide": true , 
          "thumbnailsRemainingCount": true,
          
        },
        { "breakpoint": 500, "width": "100%", "height": "300px", "thumbnailsColumns": 3 },
        { "breakpoint": 300, "width": "100%", "height": "200px", "thumbnailsColumns": 2 }
      ]
  }


  setIpAddress(){
    this._neproseService.getIPAddress().subscribe(data => {
      if(data.ip){
        this._neproseService.propertyViewed(this.property.id, data.ip).subscribe(data => { })
      }
    })
  }

  setAdvertisement(){
    this._neproseService.getLocalAds('property').subscribe(data => {
      if(data && data.status){
        this.localAds = data.localAds
        let firstAd = this.localAds.find(ad => ad.locationOfAd == 'first-box')
        if(firstAd){
          firstAd.link = this._sanitizer.bypassSecurityTrustUrl(firstAd.link)
          firstAd.imagePath = environment.api + '/images/' + firstAd.imagePath
          this.firstAd = firstAd
        }
        let secondAd = this.localAds.find(ad => ad.locationOfAd == 'second-box')
        if(secondAd){
          secondAd.link = this._sanitizer.bypassSecurityTrustUrl(secondAd.link)
          secondAd.imagePath = environment.api + '/images/' + secondAd.imagePath
          this.secondAd = secondAd
        }
        let thirdAd = this.localAds.find(ad => ad.locationOfAd == 'third-box')
        if(thirdAd){
          thirdAd.link = this._sanitizer.bypassSecurityTrustUrl(thirdAd.link)
          thirdAd.imagePath = environment.api + '/images/' + thirdAd.imagePath
          this.thirdAd = thirdAd
        }
      }
    })
  }

  isFavourite(){
    if(this._authService.accessToken){
      this.loggedIn = true
      this._neproseService.getMyFavourites().subscribe(data => {
        if(data.favorite){
          let favouriteList = data.favorite
          for(let favourite of favouriteList){
            if(favourite.property_id == this.property.id){
              this.favourite = favourite
              this.notFavourite = false
            }
          }
        }
      })
    }
  }

  addToFavourite(){
    this._neproseService.addToFavourite(this.property.id).subscribe(data => {
      if(data.status){
        this.favourite = data.favorite
        this.notFavourite = false
      }
    })
  }

  removeFromFavourite(){
    this._neproseService.deleteFromFavourite(this.favourite.id).subscribe(data => {
      if(data.status){
        this.notFavourite = true
      }
    })
  }

  prepareAdvertisement(){
    this.galleryImages = []
    let district = this.districtList.find(district => district.id == this.property.district_id)
    let municipality = this.municipalityList.find(municipality => municipality.id == this.property.municipality_id)
    this.address = municipality.municipality+', '+district.district
    if(this.property.village){
      this.address = this.property.village+', '+this.address
    }
    this.getSeller()
    if(this.property.otherFacilities){
      this.otherFacilities = JSON.parse(this.property.otherFacilities)
    }
    if(this.property.PropertyImage){
      let propertyImages = JSON.parse(this.property.PropertyImage.imagePath)
      if(propertyImages.length > 0){
        this.backgroundImageURL = this._sanitizer.bypassSecurityTrustStyle(`url(${environment.api+'/images/'+propertyImages[0]})`+` no-repeat center center`)
        for(let image of propertyImages){
          this.galleryImages.push(
            {
              small: environment.api+'/images/'+image,
              medium: environment.api+'/images/'+image,
              big: environment.api+'/images/'+image,
            }
          )
        }
      }
    }
    //Nepali Style comma separated number for price
    let lastThree = this.property.price.toString().substring(this.property.price.toString().length-3);
    let otherNumbers = this.property.price.toString().substring(0,this.property.price.toString().length-3);
    if(otherNumbers != '')
        lastThree = ',' + lastThree;
    this.property['price'] = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    //End
  }

  getSeller(){
    this.seller = this._neproseService.getSeller(this.property.user_id).pipe(share())
  }

  initializeShareButton(){
    if(isPlatformBrowser(this.platformId)){
      this.window.nativeWindow.__sharethis__.load('inline-share-buttons', {
        alignment: 'left',
        id: 'my-inline-share',
        enabled: true,
        font_size: 16,
        padding: 12,
        labels: 'none',
        networks: ['facebook', 'twitter', 'linkedin', 'messenger', 'whatsapp'],
        size: 48,
        show_mobile_buttons: true,
        show_total: false,
        spacing: 0,
        url: this.url,
      })
      this.window.nativeWindow.__sharethis__.initialize();
    }
  }

  getSimialarProperties(){
    this.similarProperties = []
    let district = this.districtList.find(district => district.id == this.property.district_id)
    this._neproseService.searchProperty('high','new','districtId', district.id, this.property.property_type_id, this.property.listingFor).subscribe(data => {
      if(data.propertiesAd){
        let similarProperties = data.propertiesAd
        if(similarProperties.length > 0){
          for(let property of similarProperties){
            if((property.id != this.adId) && (this.similarProperties.length < 3)){
              property['featuredImage'] = null
              let propertyImages = JSON.parse(property.PropertyImage.imagePath)
              if(propertyImages.length > 0){
                property.featuredImage = environment.api+'/images/'+propertyImages[0]
              }
              let municipality = this.municipalityList.find(municipality => municipality.id == property.municipality_id)
              let address = municipality.municipality
              if(property.village){
                address = property.village+', '+address
              }
              property['address'] = address

              //Nepali Style comma separated number for price
              let lastThree = property.price.toString().substring(property.price.toString().length-3);
              let otherNumbers = property.price.toString().substring(0,property.price.toString().length-3);
              if(otherNumbers != '')
                  lastThree = ',' + lastThree;
              property['price'] = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
              //End

              this.similarProperties.push(property)
            }
          }
        }
      }
    })
  }

  mapInitializer() {
    this.mapLoaded = false
    if(isPlatformBrowser(this.platformId)){
      const childElements = this.direction.nativeElement.children;
      for (let child of childElements) {
        this.renderer.removeChild(this.direction.nativeElement, child);
      }
      this.coordinates  = new google.maps.LatLng(this.property.latitude, this.property.longitude)
      this.mapOptions = {
          center: this.coordinates,
          zoom: 14
      }
      this.marker = new google.maps.Marker({
          position: this.coordinates,
          map: this.map,
          title: 'Property'
      })
      this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions)
      this.autocomplete = new google.maps.places.Autocomplete(this.location.nativeElement, this.options);
      google.maps.event.addListener(this.autocomplete, 'place_changed', ()=>{
        var place = this.autocomplete.getPlace();
        if(!this.currentMarker){
          this.currentMarker = new google.maps.Marker({
            position: place.geometry.location,
            map: this.map,
            title: 'Your Location'
          })
        }else{
          this.currentMarker.setPosition(place.geometry.location)
          this.map.setCenter(place.geometry.location)
        }
        this.currentLat = this.currentMarker.getPosition().lat()
        this.currentLong = this.currentMarker.getPosition().lng()
        this.calcRoute()
      });
      google.maps.event.addListener(this.map, 'click', (event)=> {
        var clickedLocation = event.latLng;
        if(!this.currentMarker){
          this.currentMarker = new google.maps.Marker({
            position: clickedLocation,
            map: this.map,
            title: "Your Location"
          })
        }else{
          this.currentMarker.setPosition(clickedLocation);
          this.map.setCenter(clickedLocation)
        }
        this.currentLat = this.currentMarker.getPosition().lat()
        this.currentLong = this.currentMarker.getPosition().lng()
        this.calcRoute()
      });
      this.directionsService = new google.maps.DirectionsService()
      this.directionsRenderer = new google.maps.DirectionsRenderer()
      this.infoWindow = new google.maps.InfoWindow()
      this.directionsRenderer.setMap(this.map)
      this.directionsRenderer.setPanel(this.direction.nativeElement)
      this.marker.setMap(this.map)
      this.mapLoaded = true
    }  
  }

  findMe() {
    if(isPlatformBrowser(this.platformId)){
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.showPosition(position);
        }, () => {
          this.handleLocationError(true, this.infoWindow, this.map.getCenter())
        })
      } else {
        this.handleLocationError(false, this.infoWindow, this.map.getCenter())
      }
    }  
  }

  showPosition(position) {
    if(isPlatformBrowser(this.platformId)){
      this.currentLat = position.coords.latitude
      this.currentLong = position.coords.longitude
      let location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
      this.map.panTo(location)
      this.calcRoute()
      if (!this.currentMarker) {
        this.currentMarker = new google.maps.Marker({
          position: location,
          map: this.map,
          title: 'Got you!'
        });
      }
      else {
        this.currentMarker.setPosition(location)
      }
    }  
  }

  calcRoute() {
    var request = {
      origin: this.property.latitude + ',' + this.property.longitude,
      destination: this.currentLat +',' + this.currentLong,
      provideRouteAlternatives: true,
      travelMode: this.selectedMode
    };
    this.directionsService.route(request, (response, status) => {
      if (status == 'OK') {
        this.directionsRenderer.setDirections(response);
      }
    });
  }

  handleLocationError(browserHasGeolocation: boolean, infoWindow: google.maps.InfoWindow, pos: google.maps.LatLng ){
    infoWindow.setPosition(pos);
    infoWindow.setContent(
      browserHasGeolocation
        ? "Error: The Geolocation service failed. Please Allow Location for this service."
        : "Error: Your browser doesn't support geolocation."
    );
    infoWindow.open(this.map);
  }

}
